var _ellipse, _circle, _g, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyApprovalsEmptyState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 174,
    height: 174,
    viewBox: "0 0 174 174",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 85.6566,
    cy: 86.7464,
    rx: 71.8964,
    ry: 72.1631,
    fill: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10454_2795",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 15,
    width: 144,
    height: 144
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 87,
    cy: 87,
    r: 71.0352,
    transform: "rotate(165 87 87)",
    fill: "#EBEBEB"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10454_2795)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10454_2795)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.126 30.6947C80.126 28.5412 81.8717 26.7955 84.0251 26.7955H170.726C172.879 26.7955 174.625 28.5412 174.625 30.6947V60.418C174.625 62.5714 172.879 64.3171 170.726 64.3171H84.0251C81.8717 64.3171 80.126 62.5714 80.126 60.418V30.6947Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10454_2795)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.361 39.3027H92.6329C91.8616 39.3027 91.2432 39.9281 91.2432 40.6924V50.4202C91.2432 51.1845 91.8616 51.8099 92.6329 51.8099H102.361C103.132 51.8099 103.75 51.1845 103.75 50.4202V40.6924C103.75 39.9281 103.132 39.3027 102.361 39.3027ZM96.1071 49.0305L92.6329 45.5563L93.6126 44.5766L96.1071 47.0641L101.381 41.7902L102.361 42.7769L96.1071 49.0305Z",
    fill: "#FF5000"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 110.699,
    y: 39.9976,
    width: 24.3195,
    height: 2.77938,
    rx: 1.38969,
    fill: "#DADADA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.699,
    y: 46.9461,
    width: 52.8082,
    height: 2.77938,
    rx: 1.38969,
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_10454_2795)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.6406 74.8775C64.6406 72.724 66.3863 70.9783 68.5398 70.9783H155.24C157.394 70.9783 159.139 72.724 159.139 74.8775V104.601C159.139 106.754 157.394 108.5 155.24 108.5H68.5398C66.3863 108.5 64.6406 106.754 64.6406 104.601V74.8775Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_10454_2795)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.8758 83.4854H77.148C76.3767 83.4854 75.7583 84.1108 75.7583 84.8751V94.603C75.7583 95.3673 76.3767 95.9926 77.148 95.9926H86.8758C87.6471 95.9926 88.2655 95.3673 88.2655 94.603V84.8751C88.2655 84.1108 87.6471 83.4854 86.8758 83.4854ZM80.6222 93.2133L77.148 89.739L78.1277 88.7593L80.6222 91.2469L85.8961 85.973L86.8758 86.9597L80.6222 93.2133Z",
    fill: "#FF5000"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 95.2139,
    y: 84.1802,
    width: 24.3195,
    height: 2.77938,
    rx: 1.38969,
    fill: "#DADADA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.2139,
    y: 91.1286,
    width: 52.8082,
    height: 2.77938,
    rx: 1.38969,
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_10454_2795)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.126 119.06C80.126 116.907 81.8717 115.161 84.0251 115.161H170.726C172.879 115.161 174.625 116.907 174.625 119.06V148.784C174.625 150.937 172.879 152.683 170.726 152.683H84.0251C81.8717 152.683 80.126 150.937 80.126 148.784V119.06Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_10454_2795)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.361 127.668H92.6333C91.8621 127.668 91.2437 128.294 91.2437 129.058V138.786C91.2437 139.55 91.8621 140.176 92.6333 140.176H102.361C103.132 140.176 103.751 139.55 103.751 138.786V129.058C103.751 128.294 103.132 127.668 102.361 127.668ZM96.1076 137.396L92.6333 133.922L93.6131 132.942L96.1076 135.43L101.381 130.156L102.361 131.143L96.1076 137.396Z",
    fill: "#FF5000"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 110.699,
    y: 128.363,
    width: 24.3195,
    height: 2.77938,
    rx: 1.38969,
    fill: "#DADADA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.699,
    y: 135.312,
    width: 52.8082,
    height: 2.77938,
    rx: 1.38969,
    fill: "#EBEBEB"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.293 103.991C92.293 108.469 92.3158 111.752 92.3467 111.718C92.3763 111.686 93.1481 110.642 94.0619 109.397C94.9757 108.152 95.7456 107.125 95.7728 107.116C95.8001 107.106 96.6262 108.514 97.6085 110.245L99.3946 113.391L100.711 112.618C101.653 112.065 102.02 111.819 102 111.753C101.986 111.702 101.204 110.297 100.263 108.632L98.5527 105.603L101.663 105.573L104.774 105.542L98.6174 100.923C95.231 98.3828 92.4228 96.2822 92.3767 96.2552C92.306 96.214 92.293 97.4197 92.293 103.991Z",
    fill: "#526775",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.8589 102.255C93.8589 106.733 93.8817 110.015 93.9127 109.982C93.9422 109.95 94.7141 108.905 95.6278 107.66C96.5416 106.415 97.3115 105.389 97.3388 105.379C97.3661 105.37 98.1921 106.778 99.1745 108.508L100.961 111.655L102.277 110.882C103.219 110.328 103.585 110.082 103.566 110.016C103.551 109.965 102.77 108.561 101.829 106.895L100.119 103.867L103.229 103.836L106.34 103.806L100.183 99.1868C96.797 96.6463 93.9887 94.5457 93.9426 94.5188C93.8719 94.4775 93.8589 95.6832 93.8589 102.255Z",
    fill: "#526775"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10454_2795",
    x: 61.4101,
    y: 26.7955,
    width: 131.931,
    height: 74.9533,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 18.7159
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.35793
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.619792 0 0 0 0 0.69078 0 0 0 0 0.729167 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10454_2795"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10454_2795",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_10454_2795",
    x: 45.9248,
    y: 70.9783,
    width: 131.931,
    height: 74.9533,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 18.7159
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.35793
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.619792 0 0 0 0 0.69078 0 0 0 0 0.729167 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10454_2795"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10454_2795",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_10454_2795",
    x: 61.4101,
    y: 115.161,
    width: 131.931,
    height: 74.9533,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 18.7159
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.35793
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.619792 0 0 0 0 0.69078 0 0 0 0 0.729167 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10454_2795"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10454_2795",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10454_2795"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.6763,
    height: 16.6763,
    fill: "white",
    transform: "translate(89.1587 37.2182)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_10454_2795"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.6763,
    height: 16.6763,
    fill: "white",
    transform: "translate(73.6738 81.4009)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_10454_2795"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.6763,
    height: 16.6763,
    fill: "white",
    transform: "translate(89.1592 125.584)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyApprovalsEmptyState);
export default __webpack_public_path__ + "static/media/MyApprovalsEmptyState.e383ab459b7414a091e63c8c72bf1f76.svg";
export { ForwardRef as ReactComponent };